export default __webpack_public_path__ + "static/media/almacenaje-01.e89dfb74.png";